<template lang="">
    <div>
        <p>{{ $t('achievements.completed_title')}}</p>
        <div v-for="a of achievementsCompleted" :key="a.id"><i class="pi pi-check selected"></i> {{ getTranslation(a) }}</div>
        <p class="mt-5">{{ $t('achievements.remaining_title')}}</p>
        <div  v-for="a of achievementsRemaining" :key="a.id"><i class="pi pi-check"></i> {{ getTranslation(a) }}</div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  methods: {
    getTranslation(el) {
      let ingredientsTitle = el.attributes.labels.data.find(
        (o) => o.attributes.locale === this.locale
      );
      return ingredientsTitle.attributes.title;
    },
  },
  computed: {
    locale: function () {
      return this.$store.getters["preferences/locale"];
    },
    ...mapFields("achievements", ["achievements"]),
    achievementsCompleted() {
      let achieved = this.$store.getters["profile/achieved"].map((a) => a.achievement.id);
      return this.$store.getters["achievements/achievements"].filter((a) =>
        achieved.includes(a.id)
      );
    },
    achievementsRemaining() {
      let achieved = this.$store.getters["profile/achieved"].map((a) => a.achievement.id);
      return this.$store.getters["achievements/achievements"].filter((a) =>
        !achieved.includes(a.id)
      );
    },
  },
};
</script>

<style lang="scss">
p {
  font-weight: 600;
}
div {
  font-size: 16px;
  line-height: 24px;
}

.selected {
  color: #6ab40d !important;
  font-weight: 600;
}
</style>